import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
//import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { Router, CanActivate } from "@angular/router";
import { Data } from "./DataService";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Http } from "@angular/http";
import { environment } from "src/environments/environment";
import { SocialSharing } from "@ionic-native/social-sharing/ngx";
import { FileTransfer, FileTransferObject, } from "@ionic-native/file-transfer/ngx";
import { File } from "@ionic-native/file/ngx";
import { saveAs } from "file-saver";
import { KeycloakService } from "keycloak-angular";
import { MobileService } from "./mobile.services";
import { HTTP } from "@ionic-native/http/ngx";
import { CommonService } from "./common.service";
import { SpinnerService } from "./services/spinner/spinner.service";

declare let window: any;
declare let cordova: any;
declare let device: any;
export var errorMap = [];

@Injectable({
  providedIn: "root",
})
export class ProvidehttpService implements CanActivate {
  fileUploadURL: string = "";
  keycloakURL: string = "";
  realm: string = "";
  client: string = "";
  restURL: string = "";
  showMenu = true;
  displaySide = false;
  ActiveTab = "dashboard";
  showDraft = true;
  navBarMessage = "";
  currentLanguage;
  isLanding = false;

  sessionValid = true;
  loggedIn = false;
  tfaapplet: any;
  tfaMessage: any;

  idleTimeout: number;
  idleTimer: any;
  idleTimeCount: number = 0;
  promptIdleTimeoutB4: number = 30; //in second
  isPromptTimerAlert: boolean = false;
  defaultIdleTimeout: number = 5;

  files = {
    TYPES: [
      "JPEG",
      "JPG",
      "PNG",
      "jpeg",
      "jpg",
      "pdf",
      "png",
      "xls",
      "xlsx",
      "xml",
      "xml",
      "doc",
      "docx",
      "csv",
    ],
    MIME_TYPES: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/jpeg",
      "image/jpg",
      "application/pdf",
      "image/png",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/xml",
      "text/xml",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "text/csv",
    ],
  };

  fileMimes = {
    jpeg: "image/jpeg",
    jpg: "image/jpg",
    pdf: "application/pdf",
    png: "image/png",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    xml: "application/xml",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    csv: "text/csv",
  };

  isLoggedIn(): boolean {
    return this.loggedIn && this.sessionValid;
  }

  canActivate() {
    if (this.isLoggedIn()) {
      return true;
    } else {
      this.sessionValid = false;
      this.data.formGenericData = "FLI008";
      this.router.navigate(["/logout"]);
      return false;
    }
  }

  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private data: Data,
    private http: Http,
    private socialSharing: SocialSharing,
    private transfer: FileTransfer,
    private file: File,
    private keycloakService: KeycloakService,
    private mobileService: MobileService,
    public secureHTTP: HTTP,
    private _spinnerService: SpinnerService
  ) {
    
  }

  submitLoginForm(formCode, csrf, value) {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    });

    if (csrf) {
      headers = headers.set("_CSRF", csrf);
    }

    let httpOptions = {
      headers: headers,
      withCredentials: true,
    };
    let json = {};
    json["MESSAGE"] = JSON.stringify(value);
    return this.httpClient.post<String>(
      this.restURL + "Auth/SSGW/" + formCode + "/SUBMIT",
      json,
      httpOptions
    );
  }

  resetLoginForm(formCode) {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    });

    let httpOptions = {
      headers: headers,
      withCredentials: true,
    };

    const URL = this.restURL + "Auth/SSGW/" + formCode + "/RESET";
    return this.httpClient.post(URL, "", httpOptions);
  }

  getElogoutAuthData() {
    this.loggedIn = false;
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    });

    let httpOptions = {
      headers: headers,
      withCredentials: true,
    };
    let json = {};
    let value = JSON.stringify(json);
    return this.httpClient.post<String>(
      this.restURL + "Auth/SSGW/ELOGOUT/SUBMIT",
      value,
      httpOptions
    );
  }

  domainObjectValidation(doURL, fieldValue, dependentValues, doServerUrl) {
    let headers = {
      "Content-Type": "application/json",
      //'authorization': 'Bearer ' + this.keycloakService.getKeycloakInstance().token
    };

    let httpOpts = { headers: new HttpHeaders(headers) };

    var url =
      this.getBaseURL() +
      (doServerUrl == undefined
        ? this.getCommonContext()
        : doServerUrl) +
      doURL;

    url = url.replace(
      url.substring(url.indexOf("{"), url.indexOf("}") + 1),
      fieldValue
    );

    var queryParam = "";
    dependentValues.forEach((dep, key) => {
      if (dep.paramType == undefined || dep.paramType == "PathParam") {
        url = url.replace("{" + key + "}", dep.value ? dep.value : "");
      } else if (dep.paramType == "QueryParam") {
        queryParam += key + "=" + dep.value + "&";
      }
    });

    if (queryParam.length > 0) {
      url += "?" + queryParam.substring(0, queryParam.length - 1);
    }

    return this.httpClient.get(encodeURI(url), httpOpts);
  }

  loadLookup(
    doURL,
    dependentValues,
    pageNo: number,
    searchTerm: string,
    count: number,
    doServerUrl,
    searchType: string,
    searchById: boolean = false,
  ) {
    let headers = {
      "Content-Type": "application/json",
      //'authorization': 'Bearer ' + this.keycloakService.getKeycloakInstance().token
    };

    let httpOpts = { headers: new HttpHeaders(headers) };

    var url =
      this.getBaseURL() +
      (doServerUrl == undefined
        ? this.getCommonContext()
        : doServerUrl) +
      doURL;

    url = url.replace(
      url.substring(url.indexOf("{") - 1, url.indexOf("}") + 1),
      ""
    );

    var queryParam = "";
    dependentValues.forEach((dep, key) => {
      if (dep.paramType == undefined || dep.paramType == "PathParam") {
        url = url.replace("{" + key + "}", dep.value ? dep.value : "");
      } else if (dep.paramType == "QueryParam") {
        queryParam += key + "=" + dep.value + "&";
      }
    });

    url += "?lookup=1";
    if (queryParam.length > 0) {
      url += "&" + queryParam.substring(0, queryParam.length - 1);
    }

    var criteriaDetails = {};
    if (searchTerm) {
      let filter = [];
      let filterOption = {};
      filterOption["columnName"] = searchById ? "id" : "text";
      filterOption["columnType"] = "string";
      filterOption["conditions"] = {
        searchText: searchTerm,
        // searchType: searchById ? "equals" : "Contains",
        searchType: searchType,
      };
      filter.push(filterOption);
      criteriaDetails["FilterCriteria"] = filter;
    }
    if (count > 0) {
      criteriaDetails["Count"] = count;
      criteriaDetails["Offset"] = pageNo * count + 1;
      url += "&criteriaDetails=" + JSON.stringify(criteriaDetails);
    }

    return this.httpClient.get(encodeURI(url), httpOpts);
  }

  getContextPathValue(contextPath: string, jsonObj: {}) {
    if (contextPath == undefined || contextPath == "" || jsonObj == undefined) {
      return jsonObj;
    }
    var keys = contextPath.split(".");
    var value = jsonObj;
    for (var i = 0; i < keys.length; i++) {
      value = value[keys[i]];
    }
    return value;
  }

  async onSubmit(
    formCode,
    apiGatewayCode,
    serviceCode,
    formData,
    csrf
  ): Promise<JSON> {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    });

    if (csrf) {
      headers = headers.set("_CSRF", csrf);
    }

    let httpOptions = {
      headers: headers,
      withCredentials: true,
    };
    const URL =
      this.restURL +
      "form/" +
      apiGatewayCode +
      "/" +
      formCode +
      "/" +
      serviceCode +
      "/urlaction/SUBMIT";

    let response = await this.httpClient
      .post(URL, formData, httpOptions)
      .toPromise();
    let res = JSON.parse(JSON.stringify(response));

    return res;
  }

  showSpinner() {
    //this.spinnerService.show();
  }

  hideSpinner() {
    //this.spinnerService.hide();
  }

  getMenu() {
    const httpOpts = {
      headers: new HttpHeaders({
        //'ServiceCode':'MENU'
      }),
      withCredentials: true,
    };
    return this.httpClient.get(
      this.restURL + "internal/SSGW/EHOME/MENU",
      httpOpts
    );
  }

  mapToJson(inputMap) {
    let json = {};

    if (inputMap) {
      var iterator1 = Array.from(inputMap.keys());

      for (var key of iterator1) {
        var value = inputMap.get(key);
        if (value != undefined) {
          let arry = (<any>key).split(".");
          let arryLength = arry.length;
          let jsonObj = json;
          for (let i = 0; i < arryLength; i++) {
            if (i == arryLength - 1) {
              jsonObj[arry[i]] = value;
            } else {
              if (!jsonObj[arry[i]]) {
                jsonObj[arry[i]] = {};
              }
              jsonObj = jsonObj[arry[i]];
            }
          }
        }
      }
    }

    return json;
  }

  UnAuthorizationfetchApi(
    url: string,
    method: "GET" | "POST" | "PUT" | "DELETE",
    inputMap: Map<string, any>
  ) {
    var json = this.mapToJson(inputMap);
    let headers = {
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    };
    for (let key in json["HeaderParam"]) {
      var value = json["HeaderParam"][key];
      if (value) {
        headers[key] = value;
      }
    }

    let httpOpts = { headers: new HttpHeaders(headers) };

    for (let key in json["PathParam"]) {
      var value = json["PathParam"][key];
      url = url.replace("{" + key + "}", value ? value : "");
    }

    url = this.getBaseURL() + "/cbx-common" + url;
    if (json["QueryParam"]) {
      url += "?";
      for (let key in json["QueryParam"]) {
        var value = json["QueryParam"][key];
        if (value) {
          if (typeof value != "string") {
            value = JSON.stringify(value);
          }
          url += key + "=" + value + "&";
        }
      }
      url = url.substring(0, url.length - 1);
    }

    url = encodeURI(url);

    if (
      this.mobileService.isHybrid() &&
      this.mobileService.doEnableSecureHTTP
    ) {
      var params = json["Body"] ? json["Body"] : {};
      return this.sendSecureHTTPRequest(url, method, params, headers);
    } else {
      if (method == "GET") {
        return this.httpClient.get(url, httpOpts);
      } else if (method == "POST") {
        return this.httpClient.post<String>(
          url,
          JSON.stringify(json["Body"]),
          httpOpts
        );
      } else if (method == "PUT") {
        return this.httpClient.put<String>(
          url,
          JSON.stringify(json["Body"]),
          httpOpts
        );
      } else if (method == "DELETE") {
        return this.httpClient.delete(url, httpOpts);
      }
    }
  }

  fetchApi(
    url: string,
    method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH",
    inputMap: Map<string, any>,
    serverUrl: string = undefined
  ) {
    if(method != 'GET') this._spinnerService.show();
    var json = this.mapToJson(inputMap);

    let headers = {
      "Content-Type": "application/json",
      'authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
      'languageId':environment.languageId
    };
    for (let key in json["HeaderParam"]) {
      var value = json["HeaderParam"][key];
      if (value) {
        headers[key] = value;
      }
    }

    let httpOpts: {
      headers: HttpHeaders;
      observe: any;
    } = {
      headers: new HttpHeaders(headers),
      observe: "response",
    };

    for (let key in json["PathParam"]) {
      var value = json["PathParam"][key];
      url = url.replace("{" + key + "}", value ? value : "");
    }

    // url = this.restURL.substring(0, this.restURL.length - 1)+'/publisher' + url;

    url =
      this.getBaseURL() +
      (serverUrl == undefined ? this.getCommonContext() : serverUrl) +
      url;

    if (json["QueryParam"]) {
      url += "?";
      for (let key in json["QueryParam"]) {
        var value = json["QueryParam"][key];
        if (value) {
          if (typeof value != "string") {
            value = JSON.stringify(value);
          }
          url += key + "=" + value + "&";
        } else if (value == 0 || value == "0") {
          url += key + "=" + value + "&";
        }
      }
      url = url.substring(0, url.length - 1);
    }

    url = encodeURI(url);

    if (
      this.mobileService.isHybrid() &&
      this.mobileService.doEnableSecureHTTP
    ) {
      var params = json["Body"] ? json["Body"] : {};
      return this.sendSecureHTTPRequest(url, method, params, headers);
    } else {
      if (method == "GET") {
        return this.httpClient.get(url, httpOpts).pipe(map(
          res => { return res; }
        ));
      } else if (method == "POST") {
        return this.httpClient.post(
          url,
          JSON.stringify(json["Body"]),
          httpOpts
        ).pipe(map(
          res => { this._spinnerService.hide(); return res; }
        ));
      } else if (method == "PUT") {
        return this.httpClient.put(url, JSON.stringify(json["Body"]), httpOpts).pipe(map(
          res => { this._spinnerService.hide(); return res; }
        ));
      } else if (method == "DELETE") {
        return this.httpClient.delete(url, httpOpts).pipe(map(
          res => { this._spinnerService.hide(); return res; }
        ));
      } else if (method == "PATCH") {
        return this.httpClient.patch(url, JSON.stringify(json["Body"]), httpOpts).pipe(map(
          res => { this._spinnerService.hide(); return res; }
        ));
      }
    }
  }

  downloadApi(
    url: string,
    method: "GET" | "POST" | "PUT" | "DELETE",
    inputMap: Map<string, any>,
    serverUrl: string = undefined
  ) {
    var json = this.mapToJson(inputMap);
    this.showSpinner();

    let headers = {
      "Content-Type": "application/json"
    };

    for (let key in json["HeaderParam"]) {
      var value = json["HeaderParam"][key];
      if (value) {
        headers[key] = value;
      }
    }

    let httpOpts: {
      headers: HttpHeaders;
      observe: any;
      responseType: any;
    } = {
      headers: new HttpHeaders(headers),
      observe: "response" as "body",
      responseType: "blob",
    };

    for (let key in json["PathParam"]) {
      var value = json["PathParam"][key];
      url = url.replace("{" + key + "}", value ? value : "");
    }

    // url = this.restURL.substring(0, this.restURL.length - 1)+'/publisher' + url;

    url =
      this.getBaseURL() +
      (serverUrl == undefined ? this.getCommonContext() : serverUrl) +
      url;

    if (json["QueryParam"]) {
      url += "?";
      for (let key in json["QueryParam"]) {
        var value = json["QueryParam"][key];
        if (value) {
          if (typeof value != "string") {
            value = JSON.stringify(value);
          }
          url += key + "=" + value + "&";
        } else if (value == 0 || value == "0") {
          url += key + "=" + value + "&";
        }
      }
      url = url.substring(0, url.length - 1);
    }

    url = encodeURI(url);
    var fileType =
      json["QueryParam"] && json["QueryParam"].statementType
        ? json["QueryParam"].statementType.toLowerCase()
        : "pdf";
    //var fileName = "document." + fileType;
    var path = url.split("?")[0];
    var service = path.split("/publisher/")[1];
    var fileName = "";
    if (json["fileName"]) {
      fileName = json["fileName"] + "." + fileType;
    } else {
      fileName = service.split("/").join("_") + "." + fileType;
    }

    var _this = this;

    if (
      this.mobileService.isHybrid() &&
      this.mobileService.doEnableSecureHTTP
    ) {
      var params = json["Body"] ? json["Body"] : {};
      this.secureFileDownload(url, "GET", params, headers, fileName).subscribe(
        (res) => {
          _this.downloadDocument(res, fileName, fileType);
        },
        (error) => {
          this.hideSpinner();
        }
      );
    } else {
      if (this.mobileService.isHybrid()) {
        this.pdfViewer(url, fileName);
      } else {
        this.httpClient.get(url, httpOpts).subscribe(
          (res) => {
            if (this.mobileService.isHybrid()) {
              _this.downloadDocument(res, fileName, fileType);
            } else {
              saveAs(res["body"], fileName);
              _this.hideSpinner();
            }
          },
          (error) => {
            _this.hideSpinner();
          }
        );
      }

    }

    /*this.httpClient.get(url, httpOpts).subscribe(
      (res) => {
        if (_this.data.isHybrid()) {
          _this.createBase64FromBlob(res['body'], function (docData) {

            let fileMimeIndex = _this.files.TYPES.indexOf(fileType);
            var docType = 'data:' + _this.files.MIME_TYPES[fileMimeIndex] + ';base64,';
            docData = "df:" + fileName + ";" + docType + docData.split(',')[1];

            var option = {
              message: fileName,
              subject: fileName,
              files: [docData],
              url: "",
              chooserTitle: "Share via"
            };

            _this.socialSharing.shareWithOptions(option).then((result) => {
              _this.hideSpinner();
              console.log("Share completed? ", result.completed); // On Android apps mostly return false even while it's true
              console.log("Shared to app: ", result.app); // On Android result.app is currently empty. On iOS it's empty when sharing is cancelled (result.completed=false)
            }, (err) => {
              _this.hideSpinner();
              console.log("Sharing failed with message: ", err);
            });
          });
        } else {
          saveAs(res['body'], fileName);
          this.hideSpinner();
        }
      },
      (error) => {
        this.hideSpinner();
      });*/
  }

  public downloadDocument(response, fileName, fileType) {
    var _this = this;

    this.createBase64FromBlob(response["body"], function (docData) {
      let fileMimeIndex = _this.files.TYPES.indexOf(fileType);
      var docType = "data:" + _this.files.MIME_TYPES[fileMimeIndex] + ";base64,";
      docData = "df:" + fileName + ";" + docType + docData.split(",")[1];

      if (cordova && cordova.plugins && cordova.plugins.SitewaertsDocumentViewer) {
        cordova.plugins.SitewaertsDocumentViewer.viewDocument(docData);
        return;
      }

      var option = {
        message: fileName,
        subject: fileName,
        files: [docData],
        url: "",
        chooserTitle: "Share via",
      };

      _this.socialSharing.shareWithOptions(option).then(
        (result) => {
          _this.hideSpinner();
          console.log("Share completed? ", result.completed); // On Android apps mostly return false even while it's true
          console.log("Shared to app: ", result.app); // On Android result.app is currently empty. On iOS it's empty when sharing is cancelled (result.completed=false)
        },
        (err) => {
          _this.hideSpinner();
          console.log("Sharing failed with message: ", err);
        }
      );
    });
  }

  fetchApikeycloak(
    url: string,
    method: "GET" | "POST" | "PUT" | "DELETE",
    inputMap: Map<string, any>,
    serverUrl: string = undefined
  ) {
    var json = this.mapToJson(inputMap);

    let headers = {
      "Content-Type": "application/json",
      //authorization: "Bearer " + this.keycloakService.getKeycloakInstance().token,
    };
    for (let key in json["HeaderParam"]) {
      var value = json["HeaderParam"][key];
      if (value) {
        headers[key] = value;
      }
    }

    let httpOpts: {
      headers: HttpHeaders;
      observe: any;
    } = {
      headers: new HttpHeaders(headers),
      observe: "response",
    };

    for (let key in json["PathParam"]) {
      var value = json["PathParam"][key];
      url = url.replace("{" + key + "}", value ? value : "");
    }

    url =
      this.keycloakURL +
      (serverUrl == undefined ? "/realms/" + this.realm : serverUrl) +
      url;

    if (json["QueryParam"]) {
      url += "?";
      for (let key in json["QueryParam"]) {
        var value = json["QueryParam"][key];
        if (value) {
          if (typeof value != "string") {
            value = JSON.stringify(value);
          }
          url += key + "=" + value + "&";
        }
      }
      url = url.substring(0, url.length - 1);
    }

    url = encodeURI(url);

    if (
      this.mobileService.isHybrid() &&
      this.mobileService.doEnableSecureHTTP
    ) {
      var params = json["Body"] ? json["Body"] : {};
      return this.sendSecureHTTPRequest(url, method, params, headers);
    } else {
      if (method == "GET") {
        return this.httpClient.get(url, httpOpts);
      } else if (method == "POST") {
        return this.httpClient.post(
          url,
          JSON.stringify(json["Body"]),
          httpOpts
        );
      } else if (method == "PUT") {
        return this.httpClient.put(url, JSON.stringify(json["Body"]), httpOpts);
      } else if (method == "DELETE") {
        return this.httpClient.delete(url, httpOpts);
      }
    }
  }
  checkForSession(response) {
    //   //var stringArray = ["SS00", "SS001", "SS002", "SS003", "SS004", "SS005", "SS006", "SS007", "SS008", "SS009", "SS0010", "SS0011"];
    //   var stringArray = ["FLI000", "FLI001", "FLI002", "FLI003", "FLI004", "FLI005", "FLI006", "FLI007", "FLI008", "FLI009", "FLI010", "FLI011", "FLI012", "FLI013"];
    //   if (response['Status'] == 'F') {
    //     if (stringArray.indexOf(response['error']) >= 0) {
    //       this.sessionValid = false;
    //       this.data.formGenericData = response['error'];
    //       this.router.navigate(['/logout']);
    //     }
    //   }
  }

  getFileName(cfsNumber) {
    var url = this.fileUploadURL + "getfilename?invnumber=" + cfsNumber;

    if (
      this.mobileService.isHybrid() &&
      this.mobileService.doEnableSecureHTTP
    ) {
      let headers = {
        "Content-Type": "application/json",
        authorization:
          "Bearer " + this.keycloakService.getKeycloakInstance().token,
      };
      var params = {};
      return this.sendSecureHTTPRequest(url, "GET", params, headers);
    } else {
      const httpOpts = {
        headers: new HttpHeaders({}),
        withCredentials: true,
      };
      return this.httpClient.get(url, httpOpts);
    }
  }

  async resetForm(formCode, mode) {
    let headers = {
      "Content-Type": "application/json",
      authorization:
        "Bearer " + this.keycloakService.getKeycloakInstance().token,
    };

    let httpOptions = {
      headers: new HttpHeaders(headers),
      withCredentials: true,
    };

    let json = {};
    json["MODE"] = mode;

    this.showSpinner();
    const URL =
      this.restURL + "form/SSGW/" + formCode + "/RESET" + "/urlaction/RESET";

    let formResponse;
    if (
      this.mobileService.isHybrid() &&
      this.mobileService.doEnableSecureHTTP
    ) {
      formResponse = await this.sendSecureHTTPRequest(
        URL,
        "POST",
        json,
        headers
      ).toPromise();
    } else {
      formResponse = await this.httpClient
        .post(URL, json, httpOptions)
        .toPromise();
    }
    this.hideSpinner();
    let res = JSON.parse(JSON.stringify(formResponse));
    return res;
  }

  saveAsDraft(formCode, apiGatewayCode, serviceCode, formData, RefNo, remarks) {
    let headers = {
      "Content-Type": "application/json",
      authorization:
        "Bearer " + this.keycloakService.getKeycloakInstance().token,
    };

    const httpOptions = {
      headers: new HttpHeaders(headers),
      withCredentials: true,
    };

    let Json = {
      Ref_No: RefNo,
      Data: formData,
      Remarks: remarks,
    };

    const url =
      this.restURL +
      "form/" +
      apiGatewayCode +
      "/" +
      formCode +
      "/" +
      serviceCode +
      "/urlaction/SAVEDRAFT";

    if (
      this.mobileService.isHybrid() &&
      this.mobileService.doEnableSecureHTTP
    ) {
      var params = Json ? Json : {};
      return this.sendSecureHTTPRequest(url, "POST", params, headers);
    } else {
      return this.httpClient.post(url, Json, httpOptions);
    }
  }

  loadAllDarfts(formCode, apiGatewayCode, serviceCode) {
    let headers = {
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    };

    const httpOptions = {
      headers: new HttpHeaders(headers),
      withCredentials: true,
    };
    const URL =
      this.restURL +
      "form/" +
      apiGatewayCode +
      "/" +
      formCode +
      "/" +
      serviceCode +
      "/urlaction/LOADALLDRAFTS";


    if (
      this.mobileService.isHybrid() &&
      this.mobileService.doEnableSecureHTTP
    ) {
      var params = {};
      return this.sendSecureHTTPRequest(URL, "POST", params, headers);
    } else {
      return this.httpClient.post(URL, "", httpOptions);
    }
  }

  loadDarft(formCode, apiGatewayCode, serviceCode, RefNo) {
    let headers = {
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    };

    let httpOptions = {
      headers: new HttpHeaders(headers),
      withCredentials: true,
    };

    let Json = {
      Ref_No: RefNo,
    };
    const URL =
      this.restURL +
      "form/" +
      apiGatewayCode +
      "/" +
      formCode +
      "/" +
      serviceCode +
      "/urlaction/LOADDRAFT";

    return this.httpClient.post(URL, Json, httpOptions);
  }
  deleteDarft(formCode, apiGatewayCode, serviceCode, RefNo) {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    });

    let httpOptions = {
      headers: headers,
      withCredentials: true,
    };

    let Json = {
      Ref_No: RefNo,
    };
    const URL =
      this.restURL +
      "form/" +
      apiGatewayCode +
      "/" +
      formCode +
      "/" +
      serviceCode +
      "/urlaction/DELETEDRAFT";

    return this.httpClient.post<String>(URL, Json, httpOptions);
  }

  public getJSON(): Observable<any> {
    var origin = window.location.origin + window.location.pathname;
    if (this.mobileService.isHybrid()) {
      origin = "./";
    }
    const url = origin + "assets/i18n/En.json";

    return this.http.get(url).pipe(map((res: any) => res.json()));
  }

  downloadFile(cfsNumber, fileName = undefined) {
    var _this = this;

    let headers = {
      "Content-Type": "application/json",
      authorization:
        "Bearer " + this.keycloakService.getKeycloakInstance().token,
    };

    let httpOpts: {
      headers: HttpHeaders;
      observe: any;
      responseType: any;
    } = {
      headers: new HttpHeaders(headers),
      observe: "response" as "body",
      responseType: "blob",
    };

    var url = this.fileUploadURL + "document/" + cfsNumber;
    var fileType = fileName.split(".").pop();

    if (
      this.mobileService.isHybrid() &&
      this.mobileService.doEnableSecureHTTP
    ) {
      var params = {};
      this.sendSecureHTTPRequest(url, "GET", params, headers).subscribe(
        (res) => {
          _this.downloadDocument(res, fileName, fileType);
        },
        (error) => {
          this.hideSpinner();
        }
      );
    } else {
      this.httpClient.get(url, httpOpts).subscribe(
        (res) => {
          if (this.mobileService.isHybrid()) {
            _this.downloadDocument(res, fileName, fileType);
          } else {
            saveAs(res["body"], fileName);
            _this.hideSpinner();
          }
        },
        (error) => {
          _this.hideSpinner();
        }
      );
    }
  }

  fetchImage(url: string, inputMap: Map<string, any>, callback) {
    // callback(url);
    // return;
    var json = this.mapToJson(inputMap);

    let headers = {
      "Content-Type": "application/json",
      authorization:
        "Bearer " + this.keycloakService.getKeycloakInstance().token,
    };

    for (let key in json["HeaderParam"]) {
      var value = json["HeaderParam"][key];
      if (value) {
        headers[key] = value;
      }
    }

    let httpOpts: {
      headers: HttpHeaders;
      observe: any;
      responseType: any;
    } = {
      headers: new HttpHeaders(headers),
      observe: "response" as "body",
      responseType: "blob",
    };

    if (json["QueryParam"]) {
      url += "?";
      for (let key in json["QueryParam"]) {
        var value = json["QueryParam"][key];
        if (value) {
          if (typeof value != "string") {
            value = JSON.stringify(value);
          }
          url += key + "=" + value + "&";
        }
      }
      url = url.substring(0, url.length - 1);
    }

    url = encodeURI(url);

    if (
      this.mobileService.isHybrid() &&
      this.mobileService.doEnableSecureHTTP
    ) {
      this.sendSecureHTTPRequest(url, "GET", {}, headers).subscribe((res) => {
        this.createBase64FromBlob(res["body"], callback);
      });
    } else {
      this.httpClient.get(url, httpOpts).subscribe((res) => {
        this.createBase64FromBlob(res["body"], callback);
      });
    }
  }

  createBase64FromBlob(image, callback) {
    let reader = new FileReader();
    reader.onload = function (evt) {
      callback(evt.target["result"]);
    };
    if (image) {
      reader.readAsDataURL(image);
    }
  }

  sendSecureHTTPRequest(
    url: string,
    method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH",
    params: any = {},
    headers
  ): Observable<any> {
    this.secureHTTP.setDataSerializer("json");
    let secureHTTPResponse;
    if (method == "GET") {
      secureHTTPResponse = this.secureHTTP.get(url, params, headers);
    } else if (method == "POST") {
      secureHTTPResponse = this.secureHTTP.post(url, params, headers);
    } else if (method == "PUT") {
      secureHTTPResponse = this.secureHTTP.put(url, params, headers);
    } else if (method == "DELETE") {
      secureHTTPResponse = this.secureHTTP.delete(url, params, headers);
    } else if (method == "PATCH") {
      secureHTTPResponse = this.secureHTTP.patch(url, params, headers);
    }

    return from(secureHTTPResponse).pipe(
      map((response) => {
        let newRes = {};
        newRes["body"] = response["data"] ? JSON.parse(response["data"]) : "";
        //TODO: to check 401
        return newRes;
      })
    );
  }

  secureFileDownload(
    url: string,
    method: "GET" | "POST" | "PUT" | "DELETE",
    params: any = {},
    headers,
    fileName: string
  ): Observable<any> {
    var filePath = "";
    switch (device.platform) {
      case "Android":
        filePath = cordova.file.externalDataDirectory + fileName;
        break;
      case "iOS":
        filePath = cordova.file.documentsDirectory + fileName;
        break;
    }

    return from(this.secureHTTP.downloadFile(url, params, headers, filePath));
  }
  /*SANTHOSH 18/09/2021 BEGIN*/
  fetchFileApi(
    url: string,
    inputMap: Map<string, any>,
    serverUrl: string = undefined
  ) {
    var json = this.mapToJson(inputMap);

    let headers = {
      // 'authorization': 'Bearer ' + this.keycloakService.getKeycloakInstance().token
    };
    for (let key in json["HeaderParam"]) {
      var value = json["HeaderParam"][key];
      if (value) {
        headers[key] = value;
      }
    }

    let httpOpts: any = {
      headers: new HttpHeaders(headers),
      observe: "response",
      responseType: "blob",
    };

    for (let key in json["PathParam"]) {
      var value = json["PathParam"][key];
      url = url.replace("{" + key + "}", value ? value : "");
    }

    // url = this.restURL.substring(0, this.restURL.length - 1)+'/publisher' + url;

    url =
      this.getBaseURL() +
      (serverUrl == undefined ? this.getCommonContext() : serverUrl) +
      url;

    if (json["QueryParam"]) {
      url += "?";
      for (let key in json["QueryParam"]) {
        var value = json["QueryParam"][key];
        if (value) {
          if (typeof value != "string") {
            value = JSON.stringify(value);
          }
          url += key + "=" + value + "&";
        }
      }
      url = url.substring(0, url.length - 1);
    }

    url = encodeURI(url);

    return this.httpClient.get(url, httpOpts);

  }
  /*SANTHOSH 18/09/2021 END*/

  pdfViewer(url, fileName) {
    var uri = encodeURI(url);
    var fileURL = cordova.file.documentsDirectory + fileName;
    this.downloadAndOpenPDF(uri, fileURL);
  }

  downloadAndOpenPDF(uri, fileURL) {
    this.transfer.create().download(uri, fileURL).then(
      (entry) => {
        console.log("download complete: " + entry.toURL());
        this.hideSpinner();
        cordova.plugins.fileOpener2.open(entry.toURL(), 'application/pdf',
          {
            success: function () {
              console.log('file opened successfully');
            },
            error: function (e) {
              console.log('Error status: ' + e.status + ' - Error message: ' + e.message);
            }
          }
        );
      },
      (error) => {
        console.log('file download failur');
        this.hideSpinner();
      }
    )
  }

  getBaseURL(){
    return environment.baseURL;
  }
  getCommonContext(){
    return environment.commonPublisher;
  }
  getEnvironment() {
    return environment;
  }

}
